module.exports = __webpack_public_path__ + "img/default.cd3dc5d0.svg";